"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDefaultError = exports.parseJSON = exports.checkHttpStatus = exports.statusCode401Unauthorized = exports.statusCode400BadRequest = exports.message502 = exports.message404 = exports.message401 = exports.post = exports.get = exports.fetchBackend = exports.BASE_URL = void 0;
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const config_1 = require("../../web/config");
const utils_1 = require("./utils");
const constants_1 = require("../constants/constants");
exports.BASE_URL = react_native_1.Platform.OS === constants_1.WEB_TAG ? config_1.BACKEND_URL : react_native_config_1.default.BACKEND_URL;
const fetchBackend = (endpoint, method, token, body) => {
    const controller = new AbortController();
    const { signal } = controller;
    const timeoutMs = 30 * 1000; // 30 seconds
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };
    const fetchObject = { method, headers, signal };
    // raw html concat semgrep rule disabled cause there is no input from user
    const url = `${exports.BASE_URL}${constants_1.API_URL}${endpoint}`; // nosemgrep
    if (body) {
        fetchObject.body = JSON.stringify(body);
    }
    if (token) {
        // raw html concat semgrep rule disabled cause there is no input from user
        headers.Authorization = `TOKEN ${token}`; // nosemgrep
    }
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            // Abort fetch.
            controller.abort();
            throw new Error('Connection timeout');
        }, timeoutMs);
        fetch(url, fetchObject)
            .then((response) => {
            if (timeout) {
                clearTimeout(timeout);
            }
            return resolve(response);
        })
            .catch((err) => {
            reject(err);
        });
    });
};
exports.fetchBackend = fetchBackend;
const get = (endpoint, token) => {
    return exports.fetchBackend(endpoint, 'GET', token);
};
exports.get = get;
const post = (endpoint, token, body) => {
    return exports.fetchBackend(endpoint, 'POST', token, body);
};
exports.post = post;
exports.message401 = '401';
exports.message404 = 'Page Not Found';
exports.message502 = 'Status 502 Bad Gateway';
exports.statusCode400BadRequest = 400;
exports.statusCode401Unauthorized = 401;
const checkHttpStatus = (response) => {
    if (!response) {
        throw Object.assign(new Error('Null Response Error'), {
            code: null,
            name: 'ResponseError',
        });
    }
    if (response && response.status >= 200 && response.status <= 299) {
        return response;
    }
    if (response && response.status === 401) {
        throw Object.assign(new Error(exports.message401), {
            code: response.status,
            name: 'ResponseError',
        });
    }
    if (response && response.status === 403) {
        throw Object.assign(new Error('Permission Denied'), {
            code: response.status,
            name: 'ResponseError',
        });
    }
    if (response && response.status === 404) {
        throw Object.assign(new Error(exports.message404), {
            code: response.status,
            name: 'ResponseError',
        });
    }
    if (response && response.status >= 500) {
        throw Object.assign(new Error(`Status ${response.status} ${response.statusText}`), {
            code: response.status,
            name: 'ResponseError',
        });
    }
    return response.text().then((text) => {
        let json;
        try {
            json = JSON.parse(text);
        }
        catch (e) {
            throw Object.assign(new Error(text), {
                code: response.status,
                name: 'ParsingError',
            });
        }
        if (response && response.status === 400) {
            throw new utils_1.ServerError({
                code: response.status,
                errorObject: json,
                message: response.statusText,
            });
        }
        throw Object.assign(new Error('Unexpected Error'), {
            code: response.status,
            name: 'ResponseError',
        });
    });
};
exports.checkHttpStatus = checkHttpStatus;
const parseJSON = (response) => {
    return response.text().then((text) => {
        let json;
        try {
            if (response.status !== 204) {
                json = JSON.parse(text);
            }
        }
        catch (e) {
            throw Object.assign(new Error(text), {
                code: response.status,
                name: 'ParsingError',
            });
        }
        if (response.status >= 200 && response.status < 300) {
            return json;
        }
        throw new utils_1.ServerError({
            code: response.status,
            errorObject: json,
            message: response.statusText,
        });
    });
};
exports.parseJSON = parseJSON;
const handleDefaultError = (err, rejectWithValue) => {
    if (err.message === constants_1.DEFAULT_NETWORK_ERROR_MESSAGE) {
        react_native_1.Alert.alert('Network Error', 'Unable to connect to server.\nPlease check your internet connection.');
        throw new Error(err.message);
    }
    return rejectWithValue(err);
};
exports.handleDefaultError = handleDefaultError;
